/* ShopiLED JS */
// Scroll reveal
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); revealObs.unobserve(e.target); } });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

// Mobile nav
const mobileNav = document.getElementById('mobile-nav');
document.getElementById('hamburger-btn')?.addEventListener('click', () => { mobileNav?.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
document.getElementById('mobile-nav-close')?.addEventListener('click', close);
document.querySelector('.mobile-nav__overlay')?.addEventListener('click', close);
function close() { mobileNav?.classList.remove('is-open'); document.body.style.overflow = ''; }

// Qty buttons
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.qty-control')?.querySelector('.qty-input');
    if (!input) return;
    let v = parseInt(input.value) || 1;
    input.value = btn.dataset.action === 'minus' ? Math.max(1, v - 1) : v + 1;
  });
});

// ATC feedback
document.querySelectorAll('.product-card__add').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    const badge = document.querySelector('.cart-count');
    if (badge) { badge.textContent = parseInt(badge.textContent || 0) + 1; badge.style.display = 'flex'; }
    const orig = btn.innerHTML;
    btn.innerHTML = '&#10003;'; btn.style.background = '#10b981';
    setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; }, 1400);
  });
});

// Promo form
document.querySelector('.promo-banner__form .btn--primary')?.addEventListener('click', function() {
  const input = document.querySelector('.promo-banner__input');
  if (input?.value?.includes('@')) {
    this.textContent = '&#10003; Envoyé !'; this.style.background = '#10b981';
    input.value = '';
    setTimeout(() => { this.textContent = 'Obtenir -10%'; this.style.background = ''; }, 3000);
  } else if (input) { input.style.borderColor = '#ff4757'; setTimeout(() => input.style.borderColor = '', 1500); }
});

// Variant buttons (product page)
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.product-page__variant-btns')?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// Product thumbnails
document.querySelectorAll('.product-page__thumb').forEach(t => {
  t.addEventListener('click', () => {
    t.closest('.product-page__thumbs')?.querySelectorAll('.product-page__thumb').forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  });
});

// FAQ accordion
document.querySelectorAll('.faq-question').forEach(q => {
  q.addEventListener('click', () => { q.closest('.faq-item')?.classList.toggle('open'); });
});

// Collection view toggle
window.setView = function(cols, btn) {
  const g = document.getElementById('prod-grid');
  if (g) g.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)';
  document.querySelectorAll('.coll-view-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
};
if (window.innerWidth < 600) { const g = document.getElementById('prod-grid'); if (g) g.style.gridTemplateColumns = 'repeat(2,1fr)'; }